<ng-container *ngIf="isActivitiesDetail; else autos">
  <div *ngIf="activitiesValidation" class="booking-detail-cont animated {{animation}}">
    <div class="mobileBookingDetail__header">
      <app-ds-header
        [widgetConfig]="[
          {
            Type: headerWidgetType.Title,
            Label: 'BOOKING_MODULE.YOUR_ITINERARY' | transloco,
            LabelAlign: 'center'
          },
          {
            Type: headerWidgetType.Close,
          },
        ]"
        (clickAction)="goBack()">
      </app-ds-header>
    </div>
    <div class="mobileBookingDetail__body">
      <ng-container *ngTemplateOutlet="activityResume"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #autos>
  <ng-container *ngIf="isAutoDetail; else hotel">
    <ng-container *ngTemplateOutlet="autoReservation"></ng-container>
  </ng-container>
</ng-template>

<ng-template #hotel>
  <ng-container *ngIf="isHotelDetail; else travel">
    <ng-container *ngTemplateOutlet="reservation"></ng-container>
  </ng-container>
</ng-template>

<ng-template #reservation>
  <div class="booking-detail-cont animated {{animation}}">
    <div class="header">
      <div class="reservation-header">
        <span>{{'BOOKING_MODULE.YOUR_ITINERARY' | transloco}}</span>
      </div>
      <a class="close-button" (click)="goBack()"><i aria-hidden="true" class="icon-close"></i></a>
    </div>
    <div *ngIf="hotelValidation" class="body reservation">
      <ng-container *ngTemplateOutlet="reservationItinerary"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #travel>
  <div *ngIf="airValidationSector" class="booking-detail-cont animated {{animation}}">
    <div class="header">
      <div class="reservation-header">
        <span>{{'BOOKING_MODULE.YOUR_ITINERARY' | transloco}}</span>
      </div>
      <a class="close-button" (click)="goBack()"><i aria-hidden="true" class="icon-close"></i></a>
    </div>
    <div class="body">
      <ng-container *ngTemplateOutlet="travelItinerary"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #reservationItinerary>
  <app-hotel-reservation
    [image]="hotelValidation.HotelReservation?.Hotel?.Thumbnail"
    [hotelName]="hotelValidation.HotelReservation?.Hotel?.HotelName"
    [stars]="hotelValidation.HotelReservation?.Hotel?.Category"
    [destinationName]="hotelValidation.HotelReservation?.DestinationName"
    [location]="hotelValidation.HotelReservation?.Hotel?.FullAddress"
    [checkin]="hotelValidation.HotelReservation?.Checkin"
    [checkout]="hotelValidation.HotelReservation?.Checkout"
    [rooms]="hotelValidation.HotelReservation?.Rooms"
    [provider]="hotelValidation.HotelReservation?.BookingSource"
    [isByhours]="hotelValidation.HotelReservation?.MicroStay"
    [packHours]="hotelValidation.HotelReservation?.Rooms?.[0]?.PackHour">
  </app-hotel-reservation>
  <app-policies-detail
    [hotelValidation]="hotelValidation"
    [policiesType]="policiesType"
    [isBookingView]="true">
  </app-policies-detail>
  <app-hotel-payment-detail
    [text]="hotelValidation?.TextFare"
    [guestsPerRoom]="guestsPerRoomState$ | async"
    [amount]="hotelValidation?.Amount"
    [productReference]="hotelValidation?.HotelReservation?.ProductReference"
    [pricePerNights]="pricePerNights"
    [nights]="nights"
    [conversionRate]="conversionRate$ | async"
    [isByhours]="hotelValidation.HotelReservation?.MicroStay"
    [capacity]="capacity"
    [hours]="hotelValidation.HotelReservation?.Rooms?.[0]?.PackHour">
  </app-hotel-payment-detail>
</ng-template>

<ng-template #travelItinerary>
  <app-itinerary-detail
    [isMobile]="true"
    [flightClass]="flightClass"
    [provider]="provider"
    [airValidationSector]="airValidationSector"
    [travelType]="travelType"
    [sectorSelected]="sectorSelected"
    [passengerArrangement]="passengerArrangement"
    [price]="price"
    [isLoadingFlightCabin]="isLoadingFlightCabin$ | async"
    [conversionRate]="conversionRate$ | async"
    [isInternational]="isInternational"
    [productReference]="productReference">
  </app-itinerary-detail>
</ng-template>

<ng-template #autoReservation>
  <div class="booking-detail-cont animated {{animation}}">
    <div class="header">
      <div class="reservation-header">
        <span>{{'BOOKING_MODULE.YOUR_ITINERARY' | transloco}}</span>
      </div>
      <a class="close-button" (click)="goBack()"><i aria-hidden="true" class="icon-close"></i></a>
    </div>
    <div *ngIf="autoValidation" class="body auto reservation">
      <ng-container *ngTemplateOutlet="autoReservationItinerary"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #autoReservationItinerary>
  <app-auto-reservation
    [autoValidation]="autoValidation"
    [conversionRate]="conversionRate$ | async">
  </app-auto-reservation>
</ng-template>

<ng-template #activityResume>
  <div class="mobileBookingDetail__resume">
    <app-ds-summary-card
      [type]="summaryCardType.Detailed"
      [options]="summaryOptions"
      [image]="activitiesValidation?.Products?.ProductsDetails?.[0]?.Images?.[0]"
      [title]="activityName">
    </app-ds-summary-card>
  </div>
  <div class="mobileBookingDetail__policies">
    <app-policies-detail
      [activitiesValidation]="activitiesValidation"
      [policiesType]="policiesType"
      [isBookingView]="true">
    </app-policies-detail>
  </div>
  <div class="mobileBookingDetail__payment">
    <app-payment-detail
      [isActivities]="true"
      [price]="activitiesValidation?.Products?.TotalPrice"
      [productReference]="activitiesValidation?.ProductReference"
      [conversionRate]="conversionRate$ | async">
    </app-payment-detail>
  </div>
</ng-template>